import api from "@/services/api";

const url = "suggestion";

const getSuggestion = () => api.get(url);

export default { getSuggestion };
